/* src/app/timeline-skip/modals/skip-resolve-issue/skip-resolve-issue.component.scss */
/*# sourceMappingURL=skip-resolve-issue.component.css.map */
